import React, { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { PoppinsBold } from './Fonts';
import { ReactComponent as ImagenGenerica } from '../assets/images/icons/img_generica.svg';
import { ReactComponent as ImagenDocumento } from '../assets/images/icons/ico_document.svg';

const ImageBox = ({
	src,
	caption,
	style,
	hoverAnimation,
	bg = '#E4E4E4',
	handleClick,
	className,
	...props
}) => {
	const [isHover, setIsHover] = useState(false);
	const [imageHasError, setImageHasError] = useState(!src);

	const handleMouseEnter = () => {
		if (hoverAnimation) {
			setIsHover(true);
		}
	};
	const handleMouseLeave = () => {
		setIsHover(false);
	};

	return (
		<Flex
			direction="column"
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
			className={className}
		>
			<Box
				position="relative"
				style={{
					border: '1px solid lightgray',
					backgroundColor: bg || (src && 'white'),
					width: '176px',
					height: '217px',
					borderRadius: '10px',
					cursor: 'pointer',
					overflow: 'hidden',
					...style
				}}
			>
				{imageHasError ? (
					<FallbackImage
						fill = {props.fill}
						image={{ url: src }}
						style={{ width: '100%', height: '100%' }}
					/>
				) : (
					<Box
						as={src && 'img'}
						position="absolute"
						objectFit="contain"
						style={{
							height: '100%',
							width: '100%',

							'-webkit-transition': isHover && 'all .4s ease-in-out',
							'-moz-transition': isHover && 'all .4s ease-in-out',
							'-o-transition': isHover && 'all .4s ease-in-out',
							'-ms-transition': isHover && 'all .4s ease-in-out',
							transform: isHover && 'scale(1.25)'
						}}
						src={src}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							setImageHasError(true);
						}}
						{...props}
					/>
				)}
			</Box>
			<PoppinsBold as="span" textAlign="center" color="#002575" sx="14px">
				{caption}
			</PoppinsBold>
		</Flex>
	);
};

export const FallbackImage = ({ full, onClick, style, fill = '#9a9b9f', image }) =>
	full ? (
		<Flex
			flexDir="column"
			alignItems="center"
			justifyContent="center"
			gap="30px"
			onClick={() => {
				// setCurrent(index);
			}}
			style={{
				width: '500px',
				height: '500px',
				fontSize: '10px',
				textAlign: 'center',
				borderRadius: '10px',
				//border: '1px solid #9a9b9f',
				//color: '#9a9b9f',
				...style
			}}
		>
			{image?.type === 'documento' ?
				< ImagenDocumento fill={fill}/> :
				< ImagenGenerica fill={fill}/>
			}
			<span style={{ width: '220px' }}>
				EL NAVEGADOR NO SOPORTÓ EL FORMATO DEL ARCHIVO
			</span>
		</Flex>
	) : (
		<Flex
			flexDir="column"
			alignItems="center"
			justifyContent="center"
			gap="10px"
			onClick={onClick}
			style={{
				width: '80px',
				height: '80px',
				fontSize: '10px',
				textAlign: 'center',
				borderRadius: '10px',
				border: '1px solid #9a9b9f',
				color: '#9a9b9f',
				...style
			}}
		>
			{image?.type === 'documento' ?
				< ImagenDocumento fill={fill}/> :
				<ImagenGenerica fill={fill} style={{ width: '50%', height: '50%'}} />
			}
		</Flex>
	);

export default ImageBox;
